var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remove_red_eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/image/remove_red_eye_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833333 10C2.275 6.34167 5.83333 3.75 10 3.75C14.1667 3.75 17.725 6.34167 19.1667 10C17.725 13.6583 14.1667 16.25 10 16.25C5.83333 16.25 2.275 13.6583 0.833333 10ZM17.35 10C15.975 7.19167 13.1583 5.41667 10 5.41667C6.84167 5.41667 4.025 7.19167 2.65 10C4.025 12.8083 6.83333 14.5833 10 14.5833C13.1667 14.5833 15.975 12.8083 17.35 10ZM10 7.91667C11.15 7.91667 12.0833 8.85 12.0833 10C12.0833 11.15 11.15 12.0833 10 12.0833C8.85 12.0833 7.91667 11.15 7.91667 10C7.91667 8.85 8.85 7.91667 10 7.91667ZM6.25 10C6.25 7.93333 7.93333 6.25 10 6.25C12.0667 6.25 13.75 7.93333 13.75 10C13.75 12.0667 12.0667 13.75 10 13.75C7.93333 13.75 6.25 12.0667 6.25 10Z",
    fill: "#696F88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowStripe);
export default __webpack_public_path__ + "static/media/show-stripe.6f588ab4c5ac21f63c300ffc340bd42d.svg";
export { ForwardRef as ReactComponent };